import React from "react";

export default function LoginButton({ callback, type, id }) {
  let handleChange = (event) => {
    let newValue = event.target.value;
    callback(newValue);
  };

  return (
    <input
      onChange={handleChange}
      type={type}
      className="form-control"
      id={id}
    />
  );
}
